import nakedChatList from "../views/nakedChatManage/nakedChatList";
import nakedChatBuyList from "../views/nakedChatManage/nakedChatBuyList";
import NakedChatFeedback   from "../views/nakedChatManage/nakedChatFeedback";
import Main from "../views/main";

const nakedChatRouter={
    path: "/nakedChat-list",
    component: Main,
    title: "裸聊专区管理",
    icon: "el-icon-s-promotion",
    meta: { keepAlive: true },
    children: [
    {
        path: "/nakedChat-list",
        component: nakedChatList,
        name: "nakedChatList",
        title: "裸聊专区列表",
        meta: { title: "裸聊专区列表", keepAlive: true },
      },
      {
        path: "/nakedChatBuy-list",
        component: nakedChatBuyList,
        name: "nakedChatBuyList",
        title: "裸聊购买记录",
        meta: { title: "裸聊购买记录", keepAlive: true },
      },
      {
        path: "/nakedChat-feedback",
        component: NakedChatFeedback,
        name: "nakedChatFeedback",
        title: "举报信息列表",
        meta: { title: "举报信息列表", keepAlive: true },
      }
    ]
}
export default nakedChatRouter;